module.exports = "<flash-messages></flash-messages>\n<router-outlet></router-outlet>\n<sd-modal-info></sd-modal-info>\n<sd-modal></sd-modal>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/layouts/blank.template.html
// module id = ../../../../../src/app/layout/layouts/blank.template.html
// module chunks = 3